import FirestoreCollection from './FirestoreCollection'
import TripStep from './TripStep'

export default class TripSteps extends FirestoreCollection {
  collection = 'trip-steps'

  model () {
    return TripStep
  }
}
